/** Reset browser-level scroll offsets (mobile Safari can shift the page behind fixed overlays). */
export function resetWindowScroll() {
  window.scrollTo(0, 0);
  document.documentElement.scrollTop = 0;
  document.body.scrollTop = 0;

  const root = document.getElementById("root");
  if (root) {
    root.scrollTop = 0;
  }
}

/** Reset window scroll and internal app scroll regions (see ScrollContainer). */
export function resetDocumentScroll() {
  resetWindowScroll();

  for (const el of document.querySelectorAll<HTMLElement>(".scroll-container")) {
    el.scrollTop = 0;
  }
}

export function configureManualScrollRestoration() {
  if ("scrollRestoration" in history) {
    history.scrollRestoration = "manual";
  }
}
